class SidebarMenu extends HTMLElement {
    constructor() {
        super();

        this.sidebarMenuToggler = document.querySelector('.sidebar-menu-toggler');
        this.sidebarMenuCloseButton = document.querySelector('.sidebar-menu__header__close');

        this.submenus = this.querySelectorAll('.sidebar-menu-item__submenu');
        this.submenuTogglers = this.querySelectorAll('.js-toggle-submenu');
        this.submenuCloseButtons = this.querySelectorAll('.sidebar-menu-item__submenu__header__close');

        this.submenuTogglers.forEach(toggler => {
            toggler.addEventListener('click', this.toggleSubmenu.bind(this));
        });

        this.submenuCloseButtons.forEach(closeButton => {
            closeButton.addEventListener('click', this.closeSubmenu.bind(this));
        });

        this.sidebarMenuToggler.addEventListener('click', ()=>{
            console.log('click');
            this.classList.toggle('closed');
            this.classList.toggle('opened');
        });

        this.sidebarMenuCloseButton.addEventListener('click', ()=>{
            this.classList.toggle('closed');
            this.classList.toggle('opened');
        });

        document.addEventListener('click', (event)=>{
            if(!event.target.closest('.sidebar-menu') && !event.target.closest('.sidebar-menu-toggler')){
                this.classList.add('closed');
                this.classList.remove('opened');
            }
        });
    }

    toggleSidebarMenu(event){
        this.classList.toggle('closed');
        this.classList.toggle('opened');
    }

    toggleSubmenu(event) {
        document.getElementById(event.target.dataset.submenuId).classList.add('sidebar-menu-item__submenu--open');
    }

    closeSubmenu(event) {
        document.getElementById(event.target.dataset.submenuId).classList.remove('sidebar-menu-item__submenu--open');
    }
}

customElements.define('sidebar-menu', SidebarMenu);